/*
 * store.js
 *
 * Description: Holds common/global Stores.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import Vuex from 'vuex';
import booking from './modules/booking/booking'; // 'Booking:Store'
import services from './modules/services/services'; // 'Services:Store'
import rebooking from './modules/rebooking/rebooking'; // 'Rebooking:Store'
import direct from './modules/direct/direct'; // 'Direct:Store'

import * as getters from './getters'; // global ones
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        // >>> just demo
        value: 0,
    },
    getters,
    mutations,
    actions,
    modules: {
        booking,
        services,
        rebooking,
        direct
    },
});
